<h1 mat-dialog-title>
  {{ 'containerComponents.compartmentSelection.dialog.selectCompartment' | translate }}
</h1>

<div class="list" *ngIf="assignableCompartmentListFacade.items$ | async; else notAvailable">
  <div *ngFor="let item of formGroup.get('dataControl')['controls']">
    <div class="group__title">{{ item.get('hubName').value }}</div>
    <div *ngFor="let compartment of item.get('compartments')['controls']" class="list__item">
      <mat-checkbox
        [formControl]="compartment.get('isSelected')"
        class="list__item-checkbox"
        [ngClass]="{ selected: compartment.get('isSelected').value }"
      >
        <span class="list__item-text" cropText> {{ compartment.value.name }} </span>
        <ui-svg-icon
          *ngIf="compartment.get('isSelected').value"
          [name]="iconNames.Checkmark"
          class="tw-text-bosch-green-65 list__item-checkbox-icon"
        ></ui-svg-icon>
      </mat-checkbox>
    </div>
  </div>
</div>

<div class="tw-flex tw-justify-between">
  <ui-action-button [action]="buttonAction.Cancel" (buttonClick)="closeDialog()"></ui-action-button>
  <ui-action-button [action]="buttonAction.Save" (buttonClick)="confirm()"></ui-action-button>
</div>

<ng-template #notAvailable>
  <div class="not-available">
    {{ 'containerComponents.compartmentSelection.dialog.noItems' | translate }}
  </div>
</ng-template>
